"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_jsx_runtime = require("react/jsx-runtime");
var import_vitest = require("vitest");
var import_react = __toESM(require("react"), 1);
var import_react_test_renderer = __toESM(require("react-test-renderer"), 1);
var import_Redirect = require("./Redirect");
import_vitest.vi.mock("../useFocusEffect", function() {
  return {
    useFocusEffect: function(effect, deps) {
      return import_react.default.useEffect(effect, deps);
    }
  };
});
var replaceCalls = [];
var resolvePending;
import_vitest.vi.mock("../hooks", function() {
  return {
    useRouter: function() {
      return {
        replace: function(href) {
          replaceCalls.push(href);
          return new Promise(function(resolve) {
            resolvePending = resolve;
          });
        }
      };
    }
  };
});
async function flush() {
  await (0, import_react_test_renderer.act)(async function() {
    await Promise.resolve();
    await Promise.resolve();
  });
}
(0, import_vitest.describe)("Redirect", function() {
  (0, import_vitest.it)("fires replace once across the mount/unmount churn of an auth-state settle", async function() {
    var _loop = function(i2) {
      var r = void 0;
      (0, import_react_test_renderer.act)(function() {
        r = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Redirect.Redirect, {
          href: "/home"
        }));
      });
      (0, import_react_test_renderer.act)(function() {
        r.unmount();
      });
    };
    replaceCalls.length = 0;
    for (var i = 0; i < 8; i++) _loop(i);
    (0, import_vitest.expect)(replaceCalls).toEqual([
      "/home"
    ]);
    resolvePending === null || resolvePending === void 0 ? void 0 : resolvePending();
    await flush();
    (0, import_react_test_renderer.act)(function() {
      import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Redirect.Redirect, {
        href: "/home"
      }));
    });
    (0, import_vitest.expect)(replaceCalls).toEqual([
      "/home",
      "/home"
    ]);
    resolvePending === null || resolvePending === void 0 ? void 0 : resolvePending();
    await flush();
  });
  (0, import_vitest.it)("does not re-fire within a single mounted instance", async function() {
    replaceCalls.length = 0;
    var r;
    (0, import_react_test_renderer.act)(function() {
      r = import_react_test_renderer.default.create(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Redirect.Redirect, {
        href: "/login"
      }));
    });
    (0, import_react_test_renderer.act)(function() {
      r.update(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Redirect.Redirect, {
        href: "/login"
      }));
    });
    (0, import_vitest.expect)(replaceCalls).toEqual([
      "/login"
    ]);
    resolvePending === null || resolvePending === void 0 ? void 0 : resolvePending();
    await flush();
  });
});
//# sourceMappingURL=Redirect.test.js.map
